<template>
  <mdb-modal removeBackdrop size="md" :show="modalShow" @close="handleClose">
    <mdb-modal-header class="text-center" color="indigo">
      <mdb-modal-title tag="h4" bold class="w-100 text-white">{{
        $t("change_title")
      }}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="mx-3" color="white">
      <mdb-input
        :label="$t('purchaseproduct_title')"
        type="text"
        v-model="purchaseproductnametitle"
      />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="changePurchaseProductName" color="indigo"
        >{{ $t("save") }}<mdb-icon icon="paper-plane" class="ml-1"
      /></mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbInput,
  mdbModalFooter,
  mdbModalTitle,
  mdbIcon
} from "mdbvue";
export default {
  name: "EditGameleoKeyword",
  props: {
    modalShow: Boolean,
    id: Number,
    title: String,
  },
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbModalFooter,
    mdbModalTitle,
    mdbIcon
  },
  data() {
    return {
      purchaseproductnamepath: "/1.0/front/purchaseproductname/title",
      purchaseproductnametitle: this.title,
      postdata: null,
    };
  },
  methods: {
    handleClose() {
      console.log("modal hide");
      this.$emit("modal-cancelled");
    },
    changePurchaseProductName() {
      this.postdata = JSON.stringify({
        sessionid: this.$store.getters.getToken,
        id: this.id,
        title: this.purchaseproductnametitle
      });
      this.$http 
        .post(this.purchaseproductnamepath, this.postdata)
        .then(response => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("changing_title_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort
            });
          }
          this.$emit("modal-ok");
        })
        .catch(error => {
          this.$notify.error({
            message: this.$t("changing_title_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  }
};
</script>

<style scoped></style>
